class DeviceModule {
  private _id: string = '';

  public get id() {
    return this._id;
  }

  init() {
    try {
      this._id = this.getDeviceId();
    } catch (error) {
      console.error(error);
    }
  }

  getDeviceId = () => {
    let deviceId = localStorage.getItem('device_id');
    if (!deviceId) {
      deviceId = crypto.randomUUID();
      localStorage.setItem('device_id', deviceId);
    }

    return deviceId;
  };
}

export const deviceModule = new DeviceModule();
